module.exports = __webpack_public_path__ + "static/media/YM82_2.7f2c253d.jpg";